<template>
  <section class="sectionOuterBox bgTealBlue cWhite" aria-label="Mobile app features for teachers">
    <div class="sectionInnerBox text-left">
      <v-container class="container sectionContainer">
        <v-row>
          <v-col cols="12" md="6" class="hidden-md hidden-lg hidden-xlg">
            <div class="sectionImageContainer">
              <div class="sectionImageContainer">
                <div class="sectionImage floating">
                  <img style="box-shadow: none;" class="borderRadius8"
                    src="https://cdn.planbook.com/images/welcome-mobile-teachers.png" alt="">
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <h2 class="sectionListHeader mb-4">{{ $t('mobile.teachers.title') }}</h2>
            <div>
              <ul class="sectionList pl-0">
                <li><i class="fal fa-arrow-circle-right"></i><span>{{ $t('mobile.teachers.feature1') }}</span></li>
                <li><i class="fal fa-arrow-circle-right"></i><span>{{ $t('mobile.teachers.feature2') }}</span></li>
                <li><i class="fal fa-arrow-circle-right"></i><span>{{ $t('mobile.teachers.feature3') }}</span></li>
                <li><i class="fal fa-arrow-circle-right"></i><span>{{ $t('mobile.teachers.feature4') }}</span></li>
              </ul>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="hidden-xs hidden-sm hidden-xxs">
            <div class="sectionImageContainer">
              <div class="sectionImage mobileFloating">
                <img style="box-shadow: none;" class="borderRadius8"
                  src="https://cdn.planbook.com/images/welcome-mobile-teachers.png" alt="">
              </div>
              <div class="floatingBg">
                <img src="https://cdn.planbook.com/images/welcome-mobile-blue-icons.png" alt="">
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </section>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Students extends Vue {
}
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 960px) {
  .sectionImage.floating {
    position: static !important;
    color: white
  }
}

@media only screen and (max-width: 1215) {
  .floatingBg img {
    max-width: 505px;
  }
}

.sectionOuterBox {
  padding: 21px 0;
}

.sectionImage.floating img {
  box-shadow: 0 0 15px #2b2b2b;
}

.floatingBg img {
  position: absolute;
  bottom: -20px;
  left: -40px;
  z-index: 1;
  max-width: 605px;
}

.mobileFloating {
  position: relative;
  min-height: 350px;
}

.mobileFloating img {
  position: absolute;
  bottom: -53px;
  left: 0px;
  z-index: 2;
  max-width: 535px;
}
</style>
